import { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import queryString from 'query-string';
import { resetPasswordAction } from 'Store/modules/auth/actions';
import { searchSelector } from 'Store/modules/router/selectors';
import { isValidPassword } from 'Utils/security';
import View from './view';

const initalState = {
  password: { value: '', isValid: false },
};

const RecoverPassword = (): JSX.Element => {
  const [formValues, setFormValues] = useState(initalState);
  const [validationCode, setValidationCode] = useState<string>();
  const [userEmail, setUserEmail] = useState<string>();
  const search = useSelector(searchSelector);
  const dispatch = useDispatch();
  const params = queryString.parse(search);

  useEffect(() => {
    const { code, email } = params;

    if (email) {
      setUserEmail(email as string);
    }
    if (code) {
      setValidationCode(code as string);
    }
  }, []);

  const handleOnChange = ({ id, value, isValid }): void => {
    setFormValues(prev => ({
      ...prev,
      [id]: { value, isValid },
    }));
  };

  const handleOnSubmit = (): void => {
    const dataValues = { password: formValues.password.value };
    dispatch(resetPasswordAction({ ...dataValues, email: userEmail, validationCode }));
  };

  const isValidForm = useMemo(() => {
    return isValidPassword(formValues.password.value) && formValues.password.isValid;
  }, [formValues]);

  return (
    <View
      formValues={formValues}
      onSubmit={handleOnSubmit}
      onChange={handleOnChange}
      isValidForm={isValidForm}
    />
  );
};

export default RecoverPassword;
